import { FC } from 'react';
import { Spin as AntSpin, SpinProps as AntSpinProps } from 'antd';
import * as Styled from './styles';
import { TSpinType } from 'interfaces';

type SpinProps = AntSpinProps & {
  type?: TSpinType;
  withBackground?: boolean;
};

export const Spin: FC<SpinProps> = ({
  type = 'static',
  withBackground = false,
  ...props
}) => {
  return (
    <Styled.SpinWrapper $type={type} $withBackground={withBackground}>
      <AntSpin {...props} />
    </Styled.SpinWrapper>
  );
};
